import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dropdownArrom from "../../../../assets/images/dropdown_arrow.png";
import { AuthContext } from "../../../../contexts/AuthContext";
import { bodyshellService, IBodyShellVehicleOption } from "../../../../services/bodyshellService";
import {
  associatedModelSectionSx,
  dropdownArrowSx,
  inputContainerSx,
  sectionDescriptionSx,
  sectionTitleSx,
  vehicleSelectMenuProps,
} from "./styles";

export interface IStep1Data {
  name: string;
  scale: number | "";
  vehicleModelId: string;
  vehicleName?: string;
}

interface IStepIdentification {
  formData: IStep1Data;
  onChange: (data: IStep1Data) => void;
  onValidChange: (valid: boolean) => void;
  mode?: "add" | "edit" | "view";
}
const DropdownArrow = (props: React.HTMLAttributes<HTMLSpanElement>) => (
  <Box
    {...props}
    component="img"
    src={dropdownArrom}
    alt=""
    sx={dropdownArrowSx}
  />
);

export default function StepIdentification({
  formData,
  onChange,
  onValidChange,
  mode = "add",
}: IStepIdentification) {
  const { t } = useTranslation();
  const { tokenHeaders, country: { countryCode } } = useContext(AuthContext);
  const [vehicles, setVehicles] = useState<IBodyShellVehicleOption[]>([]);

  useEffect(() => {
    if (mode === "edit" || mode === "view") return;
    bodyshellService
      .getVehicles(tokenHeaders)
      .then((res) => setVehicles(res.data))
      .catch(() => setVehicles([]));
  }, [countryCode, mode]);
  useEffect(() => {
    const isValid =
      formData.name.trim().length > 0 &&
      formData.scale !== "" &&
      formData.vehicleModelId.length > 0;
    onValidChange(isValid);
  }, [formData, onValidChange]);

  return (
    <Box >
      <Box sx={inputContainerSx}>
        <TextField
          id="bodyshell-name"
          label={t("bodyshell.step1.name")}
          value={formData.name}
          onChange={(e) => onChange({ ...formData, name: e.target.value })}
          fullWidth
          size="medium"
        />
        <FormControl fullWidth size="medium" >
          <InputLabel id="bodyshell-scale-label">
            {t("bodyshell.step1.scale")}
          </InputLabel>
          <Select
            labelId="bodyshell-scale-label"
            id="bodyshell-scale"
            IconComponent={DropdownArrow}
            value={formData.scale}
            label={t("bodyshell.step1.scale")}
            onChange={(e) => onChange({ ...formData, scale: e.target.value })}
          >
            <MenuItem value={1}>1.0</MenuItem>
            <MenuItem value={1.1}>1.1</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={associatedModelSectionSx}>
        <Typography component="h2" sx={sectionTitleSx}>
          {t("bodyshell.step1.associatedModel")}
        </Typography>
        <Typography sx={sectionDescriptionSx}>
          {t("bodyshell.step1.associatedModelInstruction")}
        </Typography>
        {mode === "edit" || mode === "view" ? (
          <TextField
            label={t("bodyshell.step1.vehicleModel")}
            value={formData.vehicleName ?? ""}
            size="medium"
            fullWidth
            disabled
          />
        ) : (
          <FormControl fullWidth size="medium" >
            <InputLabel id="bodyshell-vehicle-model-label">
              {t("bodyshell.step1.vehicleModel")}
            </InputLabel>
            <Select
              labelId="bodyshell-vehicle-model-label"
              IconComponent={DropdownArrow}
              id="bodyshell-vehicle-model"
              value={formData.vehicleModelId}
              label={t("bodyshell.step1.vehicleModel")}
              onChange={(e) =>
                onChange({ ...formData, vehicleModelId: String(e.target.value)})
              }
              MenuProps={vehicleSelectMenuProps}
            >
              {vehicles.map((vehicle) => (
                <MenuItem key={vehicle.id} value={String(vehicle.id)}>
                  {vehicle.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Box>
    </Box>
  );
}
